/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import {
  IPaginationBaseState,
  IRoleDropdown,
  OptionTypeBase,
} from "@advapacs/common";

export interface UserSearch extends IPaginationBaseState {
  searchKeyword?: string;
  page: number;
  status?: boolean;
}

export interface IUser {
  id?: string;
  username: string;
  name: string;
  email: string;
  enabled: boolean;
  password?: string;
  confirmPassword?: string;
  forcePasswordChangeNextLogin?: boolean;
  enforceTwoFactor: boolean;
  language: string;
  roleDropdown: Array<IRoleDropdown>;
  roleOptions: OptionTypeBase[];
  owner: boolean;
  totp?: boolean;
  isTwoFactorEnrolled?: boolean;
  lastLoginDateTime?: string;
}

export interface IUpdateUser {
  name: string;
  email: string;
  roles: Array<string>;
  enabled: boolean;
  enforceTwoFactor: boolean;
  language: string;
}
export interface ICreateUser extends IUpdateUser {
  username: string;
  password?: string;
  confirmPassword?: string;
  forcePasswordChangeNextLogin?: boolean;
  enforceTwoFactor: boolean;
  language: string;
}

export const defaultValue: Readonly<IUser> = {
  username: "",
  name: "",
  email: "",
  enabled: false,
  language: "en",
  password: "",
  confirmPassword: "",
  enforceTwoFactor: false,
  forcePasswordChangeNextLogin: true,
  roleDropdown: [],
  roleOptions: [],
  owner: false,
};

export interface UpdateUserPasswordProps {
  password: string;
  confirmPassword: string;
  forcePasswordChangeNextLogin: boolean;
  userId: string;
  isReload?: boolean;
}

export interface Profile {
  name?: string;
  email?: string;
  language?: string;
}

export const initSearchState: UserSearch = {
  pageSize: 10,
  page: 0,
  sort: "",
  order: "",
  searchKeyword: "",
  status: true,
};
